module.exports = __webpack_public_path__ + "img/scene_select_icon.adce8f5b.svg";